// Technical skills aligned with professional experience (Backend, Frontend, Databases, DevOps, Infrastructure, AI/ML, Tools)
export const skillsData = [
    'Python',
    'FastAPI',
    'Django',
    'Flask',
    'JavaScript',
    'TypeScript',
    'React',
    'Next JS',
    'Node.js',
    'HTML',
    'CSS',
    'Tailwind',
    'PostgreSQL',
    'MySQL',
    'MongoDB',
    'Redis',
    'Docker',
    'Kubernetes',
    'Nginx',
    'Git',
    'C',
    'REST',
    'SQLAlchemy',
    'Figma',
];
